/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsUserActivityListItem,
    MelcoModelsUserActivityListItemFromJSON,
    MelcoModelsUserActivityListItemFromJSONTyped,
    MelcoModelsUserActivityListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsUserActivityListItem
 */
export interface MelcoModelsGenericList1MelcoModelsUserActivityListItem {
    /**
     * 
     * @type {Array<MelcoModelsUserActivityListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserActivityListItem
     */
    list: Array<MelcoModelsUserActivityListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserActivityListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsUserActivityListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsUserActivityListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsUserActivityListItem {
    return MelcoModelsGenericList1MelcoModelsUserActivityListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsUserActivityListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsUserActivityListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsUserActivityListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsUserActivityListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsUserActivityListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsUserActivityListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


